function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_259",
  "data-name": "Group 259",
  transform: "translate(1877.549 -52.271)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_258",
  "data-name": "Group 258",
  transform: "translate(-1877.549 55.07)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_86",
  "data-name": "Path 86",
  d: "M-1864.811,64.595c-.169.171-.344.352-.528.533a1.157,1.157,0,0,1-1.589.041q-3.3-2.941-3.861-5.319a3.756,3.756,0,0,1-.12-.864.56.56,0,0,1-.159-.041l-2.526-.931a1.229,1.229,0,0,0-.862,0l-2.242.827a1.339,1.339,0,0,0-.852,1.257v7.285a1.288,1.288,0,0,0,1.714,1.252l1.38-.507a1.235,1.235,0,0,1,.862,0l2.526.931a1.221,1.221,0,0,0,.857,0l2.525-.931a1.236,1.236,0,0,1,.862,0l1.38.507a1.288,1.288,0,0,0,1.714-1.252V63.426C-1864.054,63.8-1864.418,64.186-1864.811,64.595Z",
  transform: "translate(1877.549 -57.936)",
  fill: "#5351fb"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_242",
  "data-name": "Group 242",
  transform: "translate(-1869.871 52.271)"
}, /*#__PURE__*/React.createElement("path", {
  id: "location",
  d: "M-1857.16,52.382a3.6,3.6,0,0,0-.854-.1,2.764,2.764,0,0,0-.414,0,4.074,4.074,0,0,0-.667.1,3.46,3.46,0,0,0-2.359,2.132,3.172,3.172,0,0,0-.176.662,3.387,3.387,0,0,0-.042.761,2.843,2.843,0,0,0,.093.708,8.384,8.384,0,0,0,2.944,3.9.9.9,0,0,0,1.211-.031c.14-.129.274-.264.4-.388a16.906,16.906,0,0,0,1.558-1.733,5.826,5.826,0,0,0,.988-1.754,2.224,2.224,0,0,0,.119-.7A3.661,3.661,0,0,0-1857.16,52.382Zm.083,3.849a1.158,1.158,0,0,1-.45.336,1.189,1.189,0,0,1-.486.1,1.18,1.18,0,0,1-.538-.129,1.189,1.189,0,0,1-.631-.75,1.074,1.074,0,0,1-.052-.341,1.209,1.209,0,0,1,.44-.936,1.223,1.223,0,0,1,.781-.285,1.224,1.224,0,0,1,.781.285,1.209,1.209,0,0,1,.44.936A1.226,1.226,0,0,1-1857.077,56.232Z",
  transform: "translate(1861.677 -52.271)",
  fill: "#5351fb"
})));

var SvgLocationMap = function SvgLocationMap(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLocationMap, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/location-map.130cb954.svg";
export { ForwardRef as ReactComponent };